// Leona — Eclipse: wraps herself in solar energy, reducing damage taken, then
// scorches the nearest enemy for physical damage.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const leonaShield: Ability = {
  id: "leonaShield",
  displayName: "Eclipse",
  description: "Reduces damage taken by 30% for 3 turns and scorches the nearest enemy for physical damage.",
  iconId: "LeonaSolarBarrier",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];

    const hits: AbilityHit[] = [
      { target: caster, amount: 0, type: "none", effect: { kind: "damageReduction", percent: 0.30, duration: 3 } },
    ];
    if (target) hits.push({ target, amount: physicalDamage(stats.ad * 1.5 + 80), type: "physical" });
    return hits;
  },
};
